// extracted by mini-css-extract-plugin
export default {"table":"styles_table__M7E0E"};